// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7e25c162","977":"9eca35fd"}[chunkId] + ".chunk.js";
};